import React from 'react'
export default({ children: iconName, type='solid', className='' }) => (
  <i className={`fa-${type} fa-${iconName} ${className}`}></i>
)